<div class="row mt-3">
  <app-progress-bar [isLoading]="isLoadingFilters"></app-progress-bar>
  
  <div class="col-md-3 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Published From</div>
      <div class="input-group input-group-sm">
        <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
          class="form-control form-control-sm" id="fromDate" placeholder="From" [(ngModel)]="linkUpdateFiltersData.fromDate"
          readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
        </div>
      </div>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </div>

  <div class="col-md-3 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label d-none d-sm-block mb-1">Published Until</div>
      <div class="input-group input-group-sm">
        <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
          class="form-control form-control-sm" id="toDate" placeholder="To" [(ngModel)]="linkUpdateFiltersData.toDate"
          readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
        </div>
      </div>
      <mat-datepicker #toPicker></mat-datepicker>
    </div>
  </div>
  <div class="col-md-2 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Regulator</div>
      <mat-chip-list #regulatorList>
        <mat-chip *ngFor="let regulator of linkUpdateFiltersData.regulator" [selectable]="selectable"
          [removable]="removable" (removed)="removeRegulator(regulator)">
          {{regulator}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip>
        <input class="form-control form-control-sm mat-autodd-input" #regulatorInput
          [formControl]="searchRegulatorCntrl" [matAutocomplete]="regulatorAutocomplete"
          [matChipInputFor]="regulatorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addRegulator($event)">
      </mat-chip-list>
      <mat-autocomplete #regulatorAutocomplete="matAutocomplete" (optionSelected)="selectedRegulator($event)">
        <mat-option *ngFor="let regulator of searchedRegulator" [value]="regulator.value">
          {{regulator.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-2 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Key Words</div>
      <mat-chip-list #keywordsList>
        <mat-chip *ngFor="let sQuery of linkUpdateFiltersData.searchQuery" [selectable]="selectable" [removable]="removable"
          (removed)="remove(sQuery)">
          {{sQuery}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip>
        <input class="form-control form-control-sm mat-autodd-input" #keywordInput [formControl]="keyCtrl"
          [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-list>
      <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let fK of filteredKeywords | async" [value]="fK">
          {{fK}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-2 col-lg-3 float-right text-right pt-4">
    <div class="form-group">
      <button type="button" class="btn btn-sm bg-purple text-white ml-2 float-lg-right text-right btn-blue text-white"
        id="btn-search" (click)="TriggerAction()">Submit</button>
      <span class="float-right ml-2 btn btn-sm pl-1" (click)="initFilters()">Reset</span>
    </div>
  </div>
</div>